import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import styles from './styles.module.css';

const STATUS_CONFIG = {
  agendado: { label: 'chatsocket.publication_status.scheduled', variant: 'scheduled' },
  scheduled: { label: 'chatsocket.publication_status.scheduled', variant: 'scheduled' },
  postado: { label: 'chatsocket.publication_status.posted', variant: 'posted' },
  posted: { label: 'chatsocket.publication_status.posted', variant: 'posted' },
  publicado: { label: 'chatsocket.publication_status.posted', variant: 'posted' },
  falhou: { label: 'chatsocket.publication_status.failed', variant: 'failed' },
  failed: { label: 'chatsocket.publication_status.failed', variant: 'failed' },
  erro: { label: 'chatsocket.publication_status.failed', variant: 'failed' },
  error: { label: 'chatsocket.publication_status.failed', variant: 'failed' },
  cancelado: { label: 'chatsocket.publication_status.canceled', variant: 'canceled' },
  canceled: { label: 'chatsocket.publication_status.canceled', variant: 'canceled' },
  cancelled: { label: 'chatsocket.publication_status.canceled', variant: 'canceled' },
  processing: { label: 'chatsocket.publication_status.processing', variant: 'scheduled' },
};

const getStatusConfig = (status) => {
  const normalizedStatus = String(status || '').trim().toLowerCase();

  return STATUS_CONFIG[normalizedStatus] || {
    label: status || 'chatsocket.publication_status.unavailable',
    variant: 'unknown',
  };
};

export const PublicationStatusBadge = ({ status, className = '' }) => {
  const { t } = useTranslation();
  const { label, variant } = getStatusConfig(status);

  return (
    <span
      className={`${styles.badge} ${styles[variant]} ${className}`.trim()}
      title={t(label)}
      aria-label={t('chatsocket.publication_status.aria_label', { label: t(label) })}
      role="status"
    >
      {t(label)}
    </span>
  );
};

PublicationStatusBadge.propTypes = {
  status: PropTypes.string,
  className: PropTypes.string,
};
